module.exports = __webpack_public_path__ + "img/impraegnierung-mineralisch.dc8a253.png";